export enum AgentStatus {
  AVAILABLE,
  UNAVAILABLE,
  OTHER,
}
